import React, { createContext, useContext, useState, useCallback, useEffect, useLayoutEffect } from 'react';
import { of, Subject, pipe, BehaviorSubject, combineLatest } from 'rxjs';
import { startWith, takeUntil, filter, map, tap, toArray, first, concatMap, withLatestFrom, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { immerable, produce } from 'immer';
import { Store, Query, applyTransaction } from '@datorama/akita';

const Type = Function;
function isType(v) {
  return typeof v === 'function';
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$B =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var FunctionPrototype$2 = Function.prototype;
var bind$6 = FunctionPrototype$2.bind;
var call$b = FunctionPrototype$2.call;
var callBind = bind$6 && bind$6.bind(call$b);

var functionUncurryThis = bind$6 ? function (fn) {
  return fn && callBind(call$b, fn);
} : function (fn) {
  return fn && function () {
    return call$b.apply(fn, arguments);
  };
};

var fails$b = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var uncurryThis$d = functionUncurryThis;

var toString$1 = uncurryThis$d({}.toString);
var stringSlice = uncurryThis$d(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var global$A = global$B;
var uncurryThis$c = functionUncurryThis;
var fails$a = fails$b;
var classof$4 = classofRaw$1;

var Object$5 = global$A.Object;
var split = uncurryThis$c(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split(it, '') : Object$5(it);
} : Object$5;

var global$z = global$B;

var TypeError$e = global$z.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$1(it));
};

var shared$3 = {exports: {}};

var global$y = global$B;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$2(global$y, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$y[key] = value;
  } return value;
};

var global$x = global$B;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$x[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.2',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var global$w = global$B;
var requireObjectCoercible = requireObjectCoercible$2;

var Object$4 = global$w.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return Object$4(requireObjectCoercible(argument));
};

var uncurryThis$b = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$b({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$a = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString = uncurryThis$a(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$h = function (argument) {
  return typeof argument == 'function';
};

var global$v = global$B;
var isCallable$g = isCallable$h;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$v[namespace]) : global$v[namespace] && global$v[namespace][method];
};

var getBuiltIn$6 = getBuiltIn$7;

var engineUserAgent = getBuiltIn$6('navigator', 'userAgent') || '';

var global$u = global$B;
var userAgent$3 = engineUserAgent;

var process$3 = global$u.process;
var Deno = global$u.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$9 = fails$b;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$t = global$B;
var shared$2 = shared$3.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$t.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$e = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$f = isCallable$h;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$f(it);
};

var global$s = global$B;
var isObject$6 = isObject$7;

var String$4 = global$s.String;
var TypeError$d = global$s.TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$6(argument)) return argument;
  throw TypeError$d(String$4(argument) + ' is not an object');
};

var fails$8 = fails$b;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty = {};

var global$r = global$B;
var isObject$5 = isObject$7;

var document$3 = global$r.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$3) && isObject$5(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$7 = fails$b;
var createElement$1 = documentCreateElement$2;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var call$a = Function.prototype.call;

var functionCall = call$a.bind ? call$a.bind(call$a) : function () {
  return call$a.apply(call$a, arguments);
};

var uncurryThis$9 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$9({}.isPrototypeOf);

var global$q = global$B;
var getBuiltIn$5 = getBuiltIn$7;
var isCallable$e = isCallable$h;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Object$3 = global$q.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$5('Symbol');
  return isCallable$e($Symbol) && isPrototypeOf$2($Symbol.prototype, Object$3(it));
};

var global$p = global$B;

var String$3 = global$p.String;

var tryToString$4 = function (argument) {
  try {
    return String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$o = global$B;
var isCallable$d = isCallable$h;
var tryToString$3 = tryToString$4;

var TypeError$c = global$o.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$6 = function (argument) {
  if (isCallable$d(argument)) return argument;
  throw TypeError$c(tryToString$3(argument) + ' is not a function');
};

var aCallable$5 = aCallable$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$5(func);
};

var global$n = global$B;
var call$9 = functionCall;
var isCallable$c = isCallable$h;
var isObject$4 = isObject$7;

var TypeError$b = global$n.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$c(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  if (isCallable$c(fn = input.valueOf) && !isObject$4(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$c(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  throw TypeError$b("Can't convert object to primitive value");
};

var global$m = global$B;
var call$8 = functionCall;
var isObject$3 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$d = wellKnownSymbol$e;

var TypeError$a = global$m.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$l = global$B;
var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var anObject$9 = anObject$a;
var toPropertyKey$1 = toPropertyKey$2;

var TypeError$9 = global$l.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$2(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var hiddenKeys$4 = {};

var uncurryThis$8 = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push = uncurryThis$8([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$3, key) && hasOwn$8(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var anObject$8 = anObject$a;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$5 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$7 = anObject$a;
var defineProperties = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$c = wellKnownSymbol$e;
var create$1 = objectCreate;
var definePropertyModule$3 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$c('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$3.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var uncurryThis$7 = functionUncurryThis;
var isCallable$b = isCallable$h;
var store$1 = sharedStore;

var functionToString = uncurryThis$7(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$k = global$B;
var isCallable$a = isCallable$h;
var inspectSource$3 = inspectSource$4;

var WeakMap$2 = global$k.WeakMap;

var nativeWeakMap = isCallable$a(WeakMap$2) && /native code/.test(inspectSource$3(WeakMap$2));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$4 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$j = global$B;
var uncurryThis$6 = functionUncurryThis;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$8 = global$j.TypeError;
var WeakMap$1 = global$j.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$8('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap$1());
  var wmget = uncurryThis$6(store.get);
  var wmhas = uncurryThis$6(store.has);
  var wmset = uncurryThis$6(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$3 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$6 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$3 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$6(O, P)) return createPropertyDescriptor$1(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var redefine$5 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$5 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$5(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$i = global$B;
var isCallable$9 = isCallable$h;
var hasOwn$4 = hasOwnProperty_1;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$2 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$5.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$9(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$3(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$i) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$3(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$9(this) && getInternalState$2(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$7;
var uncurryThis$5 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$a;

var concat$1 = uncurryThis$5([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$6 = fails$b;
var isCallable$8 = isCallable$h;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$8(detection) ? fails$6(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$h = global$B;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var redefine$4 = redefine$5.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$h;
  } else if (STATIC) {
    target = global$h[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$h[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$4(target, key, sourceProperty, options);
  }
};

var fails$5 = fails$b;

var correctPrototypeGetter = !fails$5(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$g = global$B;
var hasOwn$2 = hasOwnProperty_1;
var isCallable$7 = isCallable$h;
var toObject$2 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$2 = global$g.Object;
var ObjectPrototype = Object$2.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$2.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$2 ? ObjectPrototype : null;
};

var fails$4 = fails$b;
var isCallable$6 = isCallable$h;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$3 = redefine$5.exports;
var wellKnownSymbol$b = wellKnownSymbol$e;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$4(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$2[ITERATOR$5])) {
  redefine$3(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$a = wellKnownSymbol$e;

var TO_STRING_TAG$3 = wellKnownSymbol$a('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC) {
  if (it && !hasOwn$1(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$1(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var global$f = global$B;
var isCallable$5 = isCallable$h;

var String$2 = global$f.String;
var TypeError$7 = global$f.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$5(argument)) return argument;
  throw TypeError$7("Can't set " + String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$4 = functionUncurryThis;
var anObject$5 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$4(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$5(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$3 = _export;
var call$6 = functionCall;
var FunctionName = functionName;
var isCallable$4 = isCallable$h;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var redefine$2 = redefine$5.exports;
var wellKnownSymbol$9 = wellKnownSymbol$e;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$9('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$4(CurrentIteratorPrototype[ITERATOR$4])) {
          redefine$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$6(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    redefine$2(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$e = global$B;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol$8 = wellKnownSymbol$e;

var ITERATOR$3 = wellKnownSymbol$8('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

/**
 * The 1st injector instance is considered the 'root' injector
 * The root injector my be auto-added as a parent to all subsequent injector instances
 */
let rootInjector;
/**
 * Utility function used to easily create 1..n injectors; each with thier
 * own singletons and provider registry.
 *
 * NOTE: If only a class is registered (instead of a Provider), convert to it
 * for normalized usages
 */

function makeInjector(registry, parent) {
  const isParentDefined = typeof parent !== 'undefined'; // Always use the Provider long-form to register, e.g
  // { provide: MyClazz, useClass: MyClazz } instead of MyClazz

  const normalized = registry.map(it => {
    const isProvider = !!it.provide;
    return isProvider ? it : makeClassProvider(it);
  }); // Auto add root injector as parent unless the parent is already defined...

  const instance = new Injector(normalized, isParentDefined ? parent : rootInjector);
  !rootInjector && (rootInjector = instance);
  return instance;
}
/**
 * Injector class that manages a registry of Providers and a registry
 * of singleton instances [singletons for the instance of the injector]
 */

class Injector {
  constructor(providers = [], parent) {
    this.providers = providers;
    this.parent = parent;
    this.singletons = new WeakMap();
    this.addProviders(providers);
  }
  /**
   * Lookup singleton instance using token
   * Optionally create instance and save as singleton if needed
   * If not found, this will search a parent injector (if provided)
   */


  get(token) {
    const inst = this.findAndMakeInstance(token);
    return inst || (this.parent ? this.parent.get(token) : null);
  }
  /**
   * Force-clear internally singleton cache.
   * If parents are specified, this enforces correct parent lookups
   * for future instantiations.
   */


  reset() {
    if (this.parent) {
      this.singletons = new WeakMap();
    }
  }
  /**
   * Create an unshared, non-cached instance of the token;
   * based on the Provider configuration
   * If not found, then consider asking parent injector for the
   * instance
   */


  instanceOf(token) {
    const inst = this.instanceFromRegistry(token) || this.instanceFromParents(token);

    if (!inst) {
      throw new Error(`Unable make instance of ${String(token)}`);
    }

    return inst;
  }
  /**
   * Dynamically allow Provider registrations and singleton overwrites
   * Provide an 'restore' function to optionally restore original providers (if replaced),
   *
   * @param registry Configuration set of Provider(s)
   * @param replace Replace existing provider
   */


  addProviders(registry) {
    const origProviders = [...this.providers];
    this.providers = mergeProviders(this.providers, registry);
    registry.map(it => this.singletons.delete(it.provide));
    return () => this.addProviders(origProviders);
  }
  /**
   * Get all Token providers from parent(s), updated with current overwrites (if any).
   *
   * This allows the full parent registry tree to be flattened
   * with current level acting as overwrites
   */


  getFlatProviderTree() {
    return !this.parent ? [...this.providers] : [...mergeProviders(this.parent.getFlatProviderTree(), this.providers)];
  } // *************************************************
  // Private  Methods
  // *************************************************

  /**
   * Ask parent injectors (if any) for a flattened Provider registry,
   * then try to build the instance. When done, restore the original
   * Provider registry for this injector
   */


  instanceFromParents(token) {
    if (!this.parent) return undefined;
    const original = [...this.providers];

    try {
      this.providers = mergeProviders(this.getFlatProviderTree(), this.providers);
      return this.instanceFromRegistry(token);
    } finally {
      this.providers = original;
    }
  }
  /**
   * Find last Provider registration (last one wins)
   */


  findLastRegistration(token, list) {
    const registry = this.providers.filter(it => it.provide === token);
    return registry.length ? registry[registry.length - 1] : null;
  }
  /**
   * Based on provider registration, create instance of token and save
   * as singleton value.
   * NOTE: do not scan parent since we are caching singletons at this level only.
   *
   * @param token Class, value, or factory
   */


  findAndMakeInstance(token) {
    const isString = typeof token === 'string';
    const isNumber = !isString && typeof token === 'number';

    if (isString || isNumber) {
      return token;
    }

    let result = this.singletons.get(token);

    if (!result) {
      result = this.instanceOf(token);
      this.singletons.set(token, result);
    }

    return result;
  }

  instanceFromRegistry(token) {
    const makeAndCache = this.findAndMakeInstance.bind(this);
    const provider = this.findLastRegistration(token, this.providers);
    const deps = provider && provider.deps ? provider.deps.map(makeAndCache) : []; // const makeWithClazz = (clazz: any) => (clazz ? new clazz(...deps) : null);

    const makeWithClazz = clazz => clazz ? new (clazz.bind.apply(clazz, __doSpread.call(null, [void 0], deps)))() : null; // eslint-disable-line prefer-spread


    const makeWithFactory = fn => fn ? fn.apply(null, deps) : null; // eslint-disable-line prefer-spread


    return provider && (provider.useValue || makeWithClazz(provider.useClass) || makeWithFactory(provider.useFactory) || makeWithClazz(provider.provide)) // fallback uses the token as a `class`
    ;
  }

}
/**
 * Internal utility used to normalized Provider entries
 * during a `makeInjector()` call
 *
 * @param token
 */


function makeClassProvider(token) {
  return {
    provide: token,
    useClass: token,
    deps: [...(token['deps'] || [])]
  };
}
/**
 * Merge current provider registry with 1..n updated Provider settings;
 * where the `updated` set may contain either modified and/or new configurations
 */


function mergeProviders(current, updated) {
  const extractToken = it => it.provide;

  const findByToken = token => allEntries.find(it => it.provide === token);

  const allEntries = [...updated, ...current];
  const allTokens = new Set(allEntries.map(extractToken)); // Reduce combined set to entries unique by Token, prioritize updated entries first.

  return Array.from(allTokens).map(findByToken);
} // ***************************************************************************************************
//  Due to issues with compiling ESM with `new clazz(...deps)`, we will use a special spread function
// ***************************************************************************************************


function __doSpread(...params) {
  for (var s = 0, i = 0, il = params.length; i < il; i++) s += params[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (let a = params[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}

/**
 * React Context to 'provide' the injector
 * Used with code like:
 *
 * ```ts
 * 	export const DependencyInjectionProvider: React.FC = ({ injector, children }) => {
 *		return (
 * 				<InjectorContext.Provider value={injector}>
 *				  {children}
 *				</InjectorContext.Provider>
 *		);
 *  };
 * ```
 */

const InjectorContext = /*#__PURE__*/createContext(null);

/**
 * @description
 *
 * Creates a token that can be used in a DI Provider.
 *
 * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
 * runtime representation) such as when injecting an interface, callable type, array or
 * parameterized type.
 *
 * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
 * the `Injector`. This provides additional level of type safety.
 *
 * ```
 * interface MyInterface {...}
 * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
 * // myInterface is inferred to be MyInterface.
 * ```
 *
 * When creating an `InjectionToken`, you can optionally specify a factory function which returns
 * (possibly by creating) a default value of the parameterized type `T`. This sets up the
 * `InjectionToken` using this factory as a provider as if it was defined explicitly in the
 * application's root injector. If the factory function, which takes zero arguments, needs to inject
 * dependencies, it can do so using the `inject` function. See below for an example.
 *
 * Additionally, if a `factory` is specified you can also specify the `providedIn` option, which
 * overrides the above behavior and marks the token as belonging to a particular `@NgModule`. As
 * mentioned above, `'root'` is the default value for `providedIn`.
 *
 * @publicApi
 */
class InjectionToken {
  constructor(_desc) {
    this._desc = _desc;
  }

  toString() {
    return `InjectionToken ${this._desc}`;
  }

}

function useInjectorHook(token, injector) {
  return [injector.get(token), injector];
}

/**
 * Return either the injector instance or the token lookup FROM the
 * injector.
 *
 * A configured injector instance is required along with and a lookup token.
 * What is returned is a tuple containing the singleton instance and the injector.
 *
 * @code
 *   const injector: DependencyInjector = makeInjector([
 *     { provide: API_KEY, useValue: '873771d7760b846d51d5ac5804ab' },
 *     { provide: API_ENDPOINT, useValue: 'https://uifaces.co/api?limit=25' },
 *     { provide: ContactsService, useClass: ContactsService, deps: [API_ENDPOINT, API_KEY] }
 *   ]);
 *
 *   // Hide how DI is used under the hood
 *   // NOTE: The requires a DependencyInjectionProvider to be used for DI lookups
 *
 *   export function useContactsHook(): ContactsService {
 *     return useDependencyInjector<ContactsService>(ContactsService)
 *   }
 *
 * @returns T is either the DependencyInjector or the injector token lookup.
 */

const useDependencyInjector = token => {
  const injector = useContext(InjectorContext);
  return !token ? injector : injector.get(token);
};

/**
 * Dependency Injection is the fundamental mechanism for management of non-UI
 * entities (services, constants, facades, etc). Great DI provides:
 *
 * - Configure of dependencies between entities
 * - On-Demand construction/instantiation of entities
 * - Caching
 * - Singleton or Factory Access
 * - Easy lookups from the View Hierarchy
 * - Easy lookups for the Business Layers
 *
 */

const DependencyInjectionProvider = ({
  injector,
  children
}) => {
  return /*#__PURE__*/React.createElement(InjectorContext.Provider, {
    value: injector
  }, children);
};

const DestroyEvent = '[EventBus] destory';
const destroyEventBus = () => ({
  type: DestroyEvent
});
/**
 * Simply Pub/Sub mechanism that support decoupled communication between services
 * Note: This EventBus does cache the most recent event for EACH type...
 */

class EventBus {
  constructor(enableLogs = false) {
    this.enableLogs = enableLogs;
    this.cache = {};
    this.destroy$ = of({
      type: 'waiting'
    });
    this.emitter = new Subject();
    this.listenForDestroy();
    this.captureEvents();
  }
  /**
   * Public API to stop all current subscriptions
   * and reset with clean EventBus
   */


  reset() {
    this.emit(destroyEventBus());
  }
  /**
   * Emit an event to all listeners on this messaging queu
   */


  emit(event) {
    this.enableLogs && console.log(`[EventBus] emit(${event.type})`);
    this.emitter.next(event);
  }
  /**
   * Easily listen to a collection of events
   * And provide single teardown to disconnect all
   * internal connections.
   */


  onMany(collection) {
    const eventKeys = Object.keys(collection);
    const connections = eventKeys.map(key => this.on(key, collection[key]));
    return () => {
      connections.map(teardown => teardown());
    };
  }
  /**
   * Listen on a single event, extract data
   * Publish a teardown function to disconnect later
   */


  on(event, notify) {
    const watch$ = this.emitter.pipe(startWith(this.cache[event]), takeUntil(this.destroy$), filter(e => (e === null || e === void 0 ? void 0 : e.type) === event), map(e => e.data));
    const subscription = watch$.subscribe(data => {
      this.enableLogs && console.log(`[EventBus] on(${event})`);
      notify(data);
    });
    return subscription.unsubscribe.bind(subscription);
  }
  /**
   * Get an observable stream for a specific event
   */


  observableFor(event) {
    const watch$ = this.emitter.pipe(takeUntil(this.destroy$), filter(e => e.type === event), map(e => e.data));
    return watch$;
  }
  /**
   * Enable events to stop ALL subscriptions
   * Create special stream that ONLY emits destroy events
   */


  listenForDestroy() {
    const clearCache = () => this.cache = {};

    const onlyDestroyEvents = ({
      type
    }) => type === DestroyEvent;

    this.destroy$ = this.emitter.pipe(filter(onlyDestroyEvents), tap(clearCache));
  }
  /**
   * Activate event interceptor to record last emission for each event type
   * NOTE: do not capture the 'destroy' event
   */


  captureEvents() {
    const captureToCache = e => this.cache[e.type] = e;

    this.emitter.pipe(takeUntil(this.destroy$), tap(captureToCache)).subscribe();
  }

}

/**
 * Special hook to provide access to the 'nearest' EventBus instance.
 * From a custom hooke, developers can now easily access the
 *
 *  `notify(<event>)` and
 *  `listen(<event type>, handler)`
 *
 * features of the EventBus. This hook also manages component listeners
 * and !!auto-disconnects during dismounts.
 *
 * NOTE: this hook should ONLY be used under special circumstances. EventBus
 * messaging is NOT intended for generalized messaging.
 *
 * @returns [notifyFn, listenerFn]
 */

const useEventBus = context => {
  const injector = useContext(context || InjectorContext);
  const [eventBus] = useState(() => injector.get(EventBus));
  const [registry, setRegistry] = useState([]);
  const notify = useCallback(e => {
    eventBus.emit(e);
  }, []);
  const listen = useCallback(
  /**
   * Cache the unsubscribe AND trigger UI updates
   * since the listener is notified immediately and may
   * require UI re-renders.
   */
  (...args) => {
    const unsubscribe = eventBus.on.apply(eventBus, args);
    setRegistry(l => [...l, unsubscribe]);
  }, []);
  useEffect(() => {
    return () => {
      registry.map(unsubscribe => unsubscribe());
    };
  }, []);
  return [notify, listen];
};

/**
 * These event utils are purposed to announce entity collection changes.
 *
 * This also demonstrates how to build EventBus messaging using the `createEvent()` pattern.
 * eg   `bus.emit( itemUpdated(item) )`
 */
var CollectionEvent;

(function (CollectionEvent) {
  CollectionEvent["ITEM_ADDED"] = "itemAdded";
  CollectionEvent["ITEM_UPDATED"] = "itemUpdated";
  CollectionEvent["ITEM_REMOVED"] = "itemRemoved";
  CollectionEvent["ITEM_ERROR"] = "eventError";
})(CollectionEvent || (CollectionEvent = {}));

class ItemEvent {
  constructor(type, data) {
    this.type = type;
    this.data = data;
  }

}
const itemUpdated = item => new ItemEvent(CollectionEvent.ITEM_UPDATED, item);
const itemRemoved = itemId => new ItemEvent(CollectionEvent.ITEM_REMOVED, itemId);
const itemError = error => new ItemEvent(CollectionEvent.ITEM_ERROR, error);

var DESCRIPTORS$1 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var call$5 = functionCall;
var fails$3 = fails$b;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$4;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$3([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$5(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var global$d = global$B;

var nativePromiseConstructor = global$d.Promise;

var redefine$1 = redefine$5.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$1(target, key, src[key], options);
  return target;
};

var getBuiltIn$2 = getBuiltIn$7;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$7 = wellKnownSymbol$e;
var DESCRIPTORS = descriptors;

var SPECIES$2 = wellKnownSymbol$7('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$c = global$B;
var isPrototypeOf$1 = objectIsPrototypeOf;

var TypeError$6 = global$c.TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw TypeError$6('Incorrect invocation');
};

var uncurryThis$2 = functionUncurryThis;
var aCallable$4 = aCallable$6;

var bind$5 = uncurryThis$2(uncurryThis$2.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$4(fn);
  return that === undefined ? fn : bind$5 ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$6 = wellKnownSymbol$e;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$6('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var wellKnownSymbol$5 = wellKnownSymbol$e;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$b = global$B;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$3 = isCallable$h;
var classofRaw = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$e;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var Object$1 = global$b.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$3(O.callee) ? 'Arguments' : result;
};

var classof$2 = classof$3;
var getMethod$1 = getMethod$3;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$e;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var global$a = global$B;
var call$4 = functionCall;
var aCallable$3 = aCallable$6;
var anObject$4 = anObject$a;
var tryToString$2 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var TypeError$5 = global$a.TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$4(call$4(iteratorMethod, argument));
  throw TypeError$5(tryToString$2(argument) + ' is not iterable');
};

var call$3 = functionCall;
var anObject$3 = anObject$a;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$3(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$3(innerResult);
  return value;
};

var global$9 = global$B;
var bind$4 = functionBindContext;
var call$2 = functionCall;
var anObject$2 = anObject$a;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var TypeError$4 = global$9.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$4(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$2(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError$4(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$1(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$2(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$e;

var ITERATOR = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var uncurryThis$1 = functionUncurryThis;
var fails$2 = fails$b;
var isCallable$2 = isCallable$h;
var classof$1 = classof$3;
var getBuiltIn$1 = getBuiltIn$7;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$1(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable$2(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable$2(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$8 = global$B;
var isConstructor = isConstructor$1;
var tryToString = tryToString$4;

var TypeError$3 = global$8.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$3(tryToString(argument) + ' is not a constructor');
};

var anObject$1 = anObject$a;
var aConstructor = aConstructor$1;
var wellKnownSymbol$1 = wellKnownSymbol$e;

var SPECIES$1 = wellKnownSymbol$1('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || (S = anObject$1(C)[SPECIES$1]) == undefined ? defaultConstructor : aConstructor(S);
};

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var bind$3 = FunctionPrototype.bind;
var call$1 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (bind$3 ? call$1.bind(apply$1) : function () {
  return call$1.apply(apply$1, arguments);
});

var uncurryThis = functionUncurryThis;

var arraySlice$1 = uncurryThis([].slice);

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var classof = classofRaw$1;
var global$7 = global$B;

var engineIsNode = classof(global$7.process) == 'process';

var global$6 = global$B;
var apply = functionApply;
var bind$2 = functionBindContext;
var isCallable$1 = isCallable$h;
var hasOwn = hasOwnProperty_1;
var fails$1 = fails$b;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$2 = global$6.process;
var Dispatch = global$6.Dispatch;
var Function$1 = global$6.Function;
var MessageChannel = global$6.MessageChannel;
var String$1 = global$6.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$6.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$6.postMessage(String$1(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(isCallable$1(fn) ? fn : Function$1(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$2(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    isCallable$1(global$6.postMessage) &&
    !global$6.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$1(post)
  ) {
    defer = post;
    global$6.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$5 = global$B;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$5.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$4 = global$B;
var bind$1 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$4.MutationObserver || global$4.WebKitMutationObserver;
var document$2 = global$4.document;
var process$1 = global$4.process;
var Promise$1 = global$4.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$4, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$1(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$1(macrotask, global$4);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aCallable$2 = aCallable$6;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$2(resolve);
  this.reject = aCallable$2(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject = anObject$a;
var isObject$1 = isObject$7;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$3 = global$B;

var hostReportErrors$1 = function (a, b) {
  var console = global$3.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var engineIsBrowser = typeof window == 'object';

var $$1 = _export;
var global$2 = global$B;
var getBuiltIn = getBuiltIn$7;
var call = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine = redefine$5.exports;
var redefineAll = redefineAll$1;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable$1 = aCallable$6;
var isCallable = isCallable$h;
var isObject = isObject$7;
var anInstance = anInstance$1;
var inspectSource = inspectSource$4;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule = internalState;
var isForced = isForced_1;
var wellKnownSymbol = wellKnownSymbol$e;
var IS_BROWSER = engineIsBrowser;
var IS_NODE$1 = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$2 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global$2.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$2('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            call(then, result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$2("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$1(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reactions = state.reactions;
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE$1 ? process.domain : undefined;
      state.parent = true;
      reactions[reactions.length] = reaction;
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$1({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$1({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var global$1 = global$B;
var aCallable = aCallable$6;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$3;

var TypeError$1 = global$1.TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails = fails$b;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $ = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

/**
 * @whatItDoes reads all the values from an observable and returns a promise
 * with an array of all values. This should be used in combination with async/await.
 * NOTE:  !!This requires the stream to 'complete'
 *
 * ## Example
 *
 * ```typescript
 * const obs = of(1, 2, 3, 4);
 * const res = await readAll(obs)
 * expect(res).toEqual([1, 2, 3, 4]);
 * ```
 */

function readAll(o) {
  return o.pipe(toArray()).toPromise();
}
/**
 * @whatItDoes reads the first value from an observable and returns a promise
 * with it. This should be used in combination with async/await.
 *
 * ## Example
 *
 * ```typescript
 * const obs = of(1, 2, 3, 4);
 * const res = await readFirst(obs)
 * expect(res).toEqual(1);
 * ```
 */

function readFirst(o) {
  return o.pipe(first()).toPromise();
}

/**
 * 'concatLatestFrom' combines the source value
 * and the last available value from a lazily evaluated Observable
 * in a new array
 */

function concatLatestFrom(observablesFactory) {
  return pipe(concatMap(value => {
    const observables = observablesFactory(value);
    const observablesAsArray = Array.isArray(observables) ? observables : [observables];
    return of(value).pipe(withLatestFrom(...observablesAsArray));
  }));
}

/**
 * Manage Observable subscµription and report value emission.
 * - support dynamic reset of stream source
 * - support auto-unsubscribe when view component unmounts
 * @param observable$ Stream source
 * @param initialValue initial value; to simulate 1st stream emission
 */

function useObservable(observable$, initialValue) {
  const [source$, setObservable] = useState(observable$ || null);
  const [value, setValue] = useState(initialValue);

  const reportError = err => {
    setValue(undefined);
    console.error(`useObservable() error: ${JSON.stringify(err)}`);
  };

  useEffect(() => {
    if (source$) {
      const s = source$.subscribe(setValue, reportError);
      return () => {
        s.unsubscribe();
      };
    }
  }, [source$]);
  return [value, setObservable];
}

var _a;
const PAGE_SIZE = 20;
/**
 * Easily add in-memory Pagination features to a dataset.
 * This wrapper will internally manage pagination settings
 * and publish result page-set of data.
 *
 * @Sample:
 *
 *  // Do not use inside state management/reducers where
 *  // only 'objects' are expected during mutation
 *
 *  const paginator = new DataPaginator<PersonSummary>();
 *
 *  // Later when processing actions:
 *
 *  paginator.goToPage((action as NavigateToPage).page);
 *  const { totalPages, currentPage, paginatedList, pageSize } = paginator;
 *
 *  state = {
 *    ...state,
 *    paginator: {
 *     paginatedList,
 *      currentPage,
 *      totalPages,
 *      pageSize
 *    }
 *  };
 */

class DataPaginator {
  /**
   * Construct with rawList and options
   */
  constructor(_rawList = [], _pageSize = PAGE_SIZE, _currentPage = 1) {
    this._rawList = _rawList;
    this._pageSize = _pageSize;
    this._currentPage = _currentPage;
    this[_a] = true;
    this._paginatedList = [];
    this._totalPages = 0;
    this._pageSize = Math.max(1, Math.round(this._pageSize));
    this.goToPage(_currentPage);
  }

  get totalCount() {
    return this._rawList.length;
  }
  /**
   * Read-only accessor
   */


  get totalPages() {
    return this._totalPages;
  }
  /**
   * Read-only accessor to 1-based page marker
   */


  get currentPage() {
    return this._currentPage + 1;
  }

  get paginatedList() {
    return this._paginatedList ? [...this._paginatedList] : [];
  }
  /**
   * Always return immutable list
   */


  get rawList() {
    return [...this._rawList];
  }

  set rawList(list) {
    if (list !== this._rawList) {
      this._rawList = [...(list || [])];
      this._paginatedList = [];
      this._currentPage = -1;
      this.goToPage(1);
    }
  }

  get pageSize() {
    return this._pageSize;
  }

  set pageSize(val) {
    if (val !== this._pageSize) {
      this._currentPage = 1;
      this._paginatedList = [];
      this._pageSize = Math.max(0, Math.round(val));
      this.goToPage(1);
    }
  }
  /**
   * External users use 1-based values,
   * internal usages maintain 0-based values
   */


  goToPage(page) {
    this.updateTotalPages();
    page = Math.min(Math.max(1, page), this._totalPages);

    if (this._totalPages > 0) {
      // Use 0-based page value and force to be in-bounds
      page = Math.min(Math.max(0, Math.floor(page) - 1), this._totalPages - 1);

      if (page > -1) {
        if (page !== this._currentPage || !this._paginatedList) {
          const start = page * this._pageSize;
          const end = start + this._pageSize;

          if (start <= this.rawList.length - 1) {
            this._paginatedList = this.rawList.slice(start, end);
          }

          this._currentPage = page;
        }
      }
    }

    return this._paginatedList;
  }
  /**
   * Needed for the 'Paginator' API
   */


  setPageSize(numRowsPerPage) {
    this.pageSize = numRowsPerPage || PAGE_SIZE;
  }
  /**
   * Republish updated total num pages
   */


  updateTotalPages() {
    this._totalPages = Math.ceil(this._rawList.length / this._pageSize);

    if (!this._totalPages) {
      this._currentPage = -1;
    }
  }

}
_a = immerable;

const useStorePaginator = (rawList, pageSize = 10) => {
  const [paginator] = useState(() => new DataPaginator(rawList, pageSize));
  const setPageSize = useCallback(numRows => {
    paginator.pageSize = numRows;
    announceChanges();
  }, [paginator]);
  const goToPage = useCallback(page => {
    const results = paginator.goToPage(page);
    announceChanges();
    return results;
  }, [paginator]);
  const announceChanges = useCallback(() => {
    const {
      totalCount,
      totalPages,
      currentPage,
      paginatedList,
      pageSize
    } = paginator;
    setPaginationVM({
      totalCount,
      totalPages,
      currentPage,
      paginatedList,
      pageSize,
      goToPage,
      setPageSize
    });
  }, [paginator, goToPage, setPageSize]);
  const [vm, setPaginationVM] = useState(paginator);
  useEffect(() => {
    paginator.rawList = rawList;
    announceChanges();
    return () => {
      paginator.rawList = [];
    };
  }, [paginator, rawList, announceChanges]);
  return vm;
};

/**
 * Reactive Paginator service built-in pagination features
 * and observable updates of pagination state
 */

class RxPaginator {
  constructor(source = [], pageSize = 10) {
    this.paginator = new DataPaginator(source, pageSize);
    this.emitter = new BehaviorSubject({});
    this.pagination$ = this.emitter.asObservable();
    this.announceChanges();
  }

  goToPage(page) {
    const results = this.paginator.goToPage(page);
    this.announceChanges();
    return results;
  }

  setPageSize(numRowsPerPage) {
    this.paginator.pageSize = numRowsPerPage;
    this.announceChanges();
  }

  set dataSource(source) {
    const current = this.toSnapshot();
    this.paginator.rawList = source;
    this.paginator.goToPage(current.currentPage);
    const next = this.toSnapshot();
    const isSame = sameCount(current, next) && sameFirstItem(current, next);

    if (!isSame) {
      // Reset to show the first page
      this.paginator.goToPage(1);
    }

    this.announceChanges();
  }
  /**
   * Emit a snapshot view model of the current DataPaginator
   * state...
   */


  announceChanges() {
    const api = this.toSnapshot();
    this.emitter.next(api);
  }

  toSnapshot() {
    const {
      totalCount,
      totalPages,
      currentPage,
      paginatedList,
      pageSize
    } = this.paginator;
    return {
      totalCount,
      totalPages,
      currentPage,
      paginatedList,
      pageSize,
      goToPage: this.goToPage.bind(this),
      setPageSize: this.setPageSize.bind(this)
    };
  }

}

function sameFirstItem(a, b) {
  const sameNumItems = a.paginatedList.length === b.paginatedList.length;

  const firstID = target => target.paginatedList.length ? target.paginatedList[0].id : null;

  return sameNumItems && firstID(a) === firstID(b);
}

function sameCount(a, b) {
  return a.totalCount === b.totalCount && a.totalPages === b.totalPages;
}

let __DEV__ = true;

function isDev() {
  return __DEV__;
}

const useIsoLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

const identity = s => s;

const NOOP = () => {};
/**
 * Create a store with specified state
 *
 * The store instances is actually a React hook with Store API added
 * All stores are decorated with Status state (isLoading, error, setIsLoading, and setError)
 *
 * @returns useStore: Hook that will emit either all state or partial state [based on passed selector].
 */


function createStore(createState, options = {}) {
  /**
   * During store startup configuration, we may need to capture
   * initial state and notify store to allow side affects.
   *
   * NOTE: this initialization is for the STORE not for the hook usage...
   *       !!store.reset() does NOT affect the sideaffects from initialization
   */
  const initializer = {
    state: null,
    completed: false,
    registerOnInit: (effect, deps) => {
      initializer.onInit = () => {
        initializer.completed = true;
        const unsubscribe = effect();
        initializer.onDestroy = !!unsubscribe && typeof unsubscribe === 'function' ? unsubscribe : NOOP;
      };
    },
    onInit: NOOP,
    onDestroy: NOOP // call to store is destroyed and cleanup from onReady() activity

  };
  let paginator = new RxPaginator();
  const computed = {};
  const name = options.storeName || `ReactAkitStore${Math.random()}`;
  const resettable = options.hasOwnProperty('autoReset') ? !!options.autoReset : false;
  const recompute = new BehaviorSubject({});
  /**
   * Internal Akita Store + Query instances
   * Note: Immer immutability is auto-applied via the `producerFn` configuration
   */

  const store = new Store({}, {
    producerFn: produce,
    name,
    resettable
  });
  const query = new Query(store);
  /**
   * setIsLoading() + setError()
   * Status API methods available on 'api'
   */

  const setIsLoading = (isLoading = true) => store.update(s => Object.assign(Object.assign({}, s), {
    isLoading
  }));

  const setError = error => {
    store.update(s => Object.assign(Object.assign({}, s), {
      error
    }));
  };
  /**
   * setState() + getState()
   * Build API methods used that delegate to the store and query
   */


  const getState = store.getValue.bind(store);

  const setState = (partial, replace = false) => {
    const isCallback = partial instanceof Function;

    const updateWithValue = s => replace ? s : Object.assign(Object.assign({}, s), partial);

    store.update(!isCallback ? updateWithValue : partial);
  };

  const applyTransaction$1 = (action, options) => {
    const msg = phase => `---- ${phase} applyTransaction() ----- `;

    const log = phase => (options === null || options === void 0 ? void 0 : options.enableLog) && isDev() && console.log(msg(phase));

    log('start');
    const response = applyTransaction(action, options === null || options === void 0 ? void 0 : options.thisArg);
    log('stop');
    return response;
  };
  /**
   * subscribe()
   * The subscribe function allows components to bind to a state-portion without forcing re-render on changes
   */


  const subscribe = (listener, selector) => {
    const onNext = s => listener(s);

    const watcher = query.select(selector || identity).subscribe(onNext);
    return () => watcher.unsubscribe();
  };
  /**
   * addComputedProperty()
   *
   * Inject the computed property into the target 'state':
   *
   * - Subscribe to state changes with the computed property selectors
   * - Use the computed property predicate function to map to a 'value' response
   * - update the targeted computed property with the 'value' response
   *
   * This method is used inside createStore() to configure watches during state
   * initialization.
   *
   * NOTE: At this point, the store/query are not yet ready!! we 'queue' these requests
   *       and later in `registerComputedProperties()` we finish the setup
   *       for all computed properties
   */


  const addComputedProperty = (store, property) => {
    const list = normalizeProperties(property);
    list.map(it => {
      const deferredSetup = () => {
        if (validateComputedProperty(store, it)) {
          const makeQuery = predicate => query.select(predicate);

          const selectors = normalizeSelector(it.selectors);
          const emitters = selectors.map(makeQuery);
          const sources$ = emitters.length > 1 ? combineLatest([...emitters, recompute.asObservable()]) : emitters[0];
          const computed$ = sources$.pipe(map(it.transform), debounceTime(2));

          const onComputedChanged = computedValue => {
            setState(s => Object.assign(Object.assign({}, s), {
              [it.name]: computedValue
            }));
          };

          if (it.hasOwnProperty('initialValue')) {
            const value = valueFrom(it.initialValue);
            setState(s => Object.assign(Object.assign({}, s), {
              [it.name]: value
            }));
          }

          const subscription = computed$.subscribe(onComputedChanged);
          return () => subscription.unsubscribe();
        }

        throw new Error(`[createStore::addComputedProperty( '${it.name}' )] Invalid Store Selectors`);
      };

      computed[it.name] = !initializer.completed ? deferredSetup : deferredSetup();
    });
    return store;
  };
  /**
   * Watch for changes in a specific property and then notify 'listener'
   * This method is used inside createStore() to configure watches during state
   * initialization.
   *
   * NOTE: Unlike observe() which does NOT trigger component rerenders, the 'listener'
   *       has access to `set`; which (if used) will trigger rerenders
   */


  const watchProperty = (store, property, listener) => {
    if (!listener) {
      throw new Error(`ReactiveStore watchProperty() requires a StateSliceListener to watch for ${property} changes.`);
    }

    const deferredSetup = () => {
      if (validateWatchedProperty(store, property)) {
        const selector = s => s[property];

        const source$ = query.select(selector).pipe(debounceTime(3), distinctUntilChanged());
        listener(selector(store)); // Notify listener immediately

        const watcher = source$.subscribe(listener);
        return () => watcher.unsubscribe();
      }

      return () => {};
    };

    computed[property] = !initializer.completed ? deferredSetup : deferredSetup();
    return store;
  };
  /**
   * Activate all 'queued' computed/watched properties
   */


  const registerComputedProperties = () => {
    Object.keys(computed).map(propertyName => {
      const registerNow = computed[propertyName];
      computed[propertyName] = registerNow();
    });
  };
  /**
   * Complete streams and close the store
   */


  const destroy = () => {
    Object.keys(computed).map(propertyName => {
      const unsubscribe = computed[propertyName];
      unsubscribe();
    });
    store.destroy(); // release internal state and streams

    initializer.onDestroy(); // enable store cleanup of custom side affects
  };
  /**
   * Do not auto-destroy the store on hook/component dismount
   * stores can be shared and persistent between mountings.
   *
   * Reset() for two conditions:
   *
   * (1) Dismount - When component unmounts and the hook is released,
   *                ^ this requires options 'resettable' to be true
   * (2) Imperative - When shared state should be cleared/reset
   *                  ^ available anytime so the shared hook can reset state
   *
   * Reset store to initial state and force recompute of properties
   *
   */


  const reset = (forced = false) => {
    const state = initializer.state || {}; // we need our computed values to recompute.

    resettable && store.reset();
    recompute.next(Object.assign({}, state));

    if (forced) {
      const nextState = produce({}, () => Object.assign({}, state));

      store._setState(nextState);
    }
  }; // unsubscribe from paginator.pagination$ stream


  let unsubscribe = NOOP;
  /**
   * Optional Paginator API available within the createStore factory
   *
   * The target 'rawlist' is unaffected and passed thru...Meanwhile,
   * the paginated list internally manages a clone of original target 'rawlist'
   */

  const paginate = (rawList, pageSize = 20) => {
    const watchPaginator = () => {
      const stream$ = paginator.pagination$;
      const subscription = stream$.subscribe(pagination => {
        setState(s => {
          s.pagination = pagination;
        });
      });
      unsubscribe = subscription.unsubscribe.bind(subscription);
    };

    paginator = new RxPaginator(rawList, pageSize);
    unsubscribe(); // Defaults to NOOP, L298 can assign override.

    watchPaginator(); // Watch and reset unsubscribe() to valid cleanup

    return rawList;
  };
  /**
   * Decorate the paginate function with a tail-hook;
   * to allow the `paginate()` feature to compose 'on' another function
   * e.g
   *    addComputedProperty(store, {
   *      name: 'evenKeys',
   *      selectors: (s) => s.allKeys,
   *      transform: paginate.on(computeEvenKeys)
   *    });
   *
   */


  paginate.on = (fn, pageSize = 20) => {
    return (...args) => {
      const results = fn.apply(null, args); // Start a side affect to update pagination OUTSIDE computed property
      // transforms.

      new Promise(resolve => {
        paginate(results, pageSize);
      });
      return results;
    };
  };
  /**
   * Create the Store instance with desired API
   */


  const storeAPI = {
    get: getState,
    set: setState,
    applyTransaction: applyTransaction$1,
    addComputedProperty: addComputedProperty,
    watchProperty: watchProperty,
    setIsLoading,
    setError,
    paginate // easily set pagination state and API for target dataset

  };
  const hookAPI = {
    observe: subscribe,
    destroy: destroy,
    reset: () => reset(true) // allow hook-level resets of store information; without destroying streams

  };
  /**
   * Internal utility methods for selectors
   *
   * toObservable(): Build an RxJS stream for the specified selector(s)
   * toStateSlice(): Gather current state values for the specified selector(s)
   */

  const toObservable = selector => {
    const list = normalizeSelector(selector);

    const buildQueries = () => list.map(it => query.select(it));

    const buildStream = () => list.length ? combineLatest(buildQueries()) : query.select(identity);

    return buildStream().pipe(debounceTime(10));
  };

  const getSliceValueFor = (selector = identity) => {
    const list = selector instanceof Array ? selector : null;

    const getCurrent = it => it(getState());

    return list ? list.map(getCurrent) : getCurrent(selector);
  };
  /**
   * userStore()
   *
   * After the store has been created and initialized with api + state, this hoook
   * is created. Developer will use this custom react hook to 'select' state data.
   * The selected data sources will re-emit data after changes.
   *
   * This hook is implicitly connected to its associated [parent] store
   *
   * Warning!!
   *   1) Do not use same 'useStore' hook multiple times in the same component.
   *   2) To extract multiple slices, use
   *      a) a single selector to return a reponse (value, hashmap, or tuple)
   *      b) an array of selectors [optimized approach] to return response
   */


  const useStore = selector => {
    const [initial] = useState(() => getSliceValueFor(selector));
    const [slice, setSlice$] = useObservable(null, initial);
    useIsoLayoutEffect(() => {
      setSlice$(toObservable(selector));
      return () => {
        reset();
      };
    }, [selector]);
    return slice;
  };
  /**
   * Initialization of state management
   * Create the immutable state using the 'createState()' custom store
   * factory function
   *
   * - Reinitialize the internal store,
   * - Register computed and watched properties
   * - inject storeAPI
   */


  const initializeStore = () => {
    initializer.state = produce({}, () => Object.assign(Object.assign({
      error: null,
      isLoading: false
    }, {
      pagination: {
        paginatedList: [],
        totalCount: 0,
        totalPages: 1,
        currentPage: 1,
        pageSize: 20
      }
    }), createState(Object.assign(Object.assign({}, storeAPI), hookAPI), // provide to custom store internal functions
    initializer.registerOnInit // enable custom store to register for useStoreEffect notifications
    )));
    reinitStore(store, name, initializer.state);
    registerComputedProperties(); // Notify store initialization is done and side affects are now allowed

    initializer.onInit(); // Decorate hook function with API methods, public custom hook/store

    return Object.assign(useStore, hookAPI);
  };

  return initializeStore();
}

function reinitStore(store, name, state) {
  if (!!name && store.storeName != name) {
    const config = store.constructor.akitaConfig;
    const options = store['options'];
    config.storeName = name;
    options.storeName = name;
  } // Reinitalize


  store['onInit'](state);
}
/**
 * Ensure that a 'list' of selectors is available for upcoming iteration
 */


function normalizeSelector(selectors) {
  const nonNull = it => !!it;

  return Array.isArray(selectors) ? selectors : [selectors].filter(nonNull);
}
/**
 * Ensure that the 'list' of computedProperties is available for upcoming iteration
 */


function normalizeProperties(list) {
  const isArray = list instanceof Array;
  return isArray ? list : [list];
}
/**
 * Computed property validation
 *  - is the property defined in the state (eg should have a placeholder starting value)
 *  - are you using 2 or more state selectors
 */


function validateComputedProperty(store, property) {
  const isValidProperty = validateWatchedProperty(store, property.name, 'ComputedProperty');
  const validSelectors = validateSelectors(store, property.selectors);

  if (!validateSelectors) {
    console.error(`
      ComputedProperty '${property.name}' cannot select the store. 
      Please specify 1 or more properites within the store.    
    `);
  }

  return isValidProperty && validSelectors;
}
/**
 * Computed property validation
 *  - is the property defined in the state (eg should have a placeholder starting value)
 *  - are you using 2 or more state selectors
 */


function validateWatchedProperty(store, name, fieldType = 'WatchProperty') {
  const hasProperty = store.hasOwnProperty(name);

  if (!hasProperty && isDev()) {
    console.warn(`
      ${fieldType} '${name}' may not be a valid property in your store. 
    `);
  }

  return hasProperty;
}
/**
 * No selector is allowed to select entire store/state
 * @param store
 * @param current List of state selectors OR a single selector
 * @returns boolean All selectors are valid
 */


function validateSelectors(store, current) {
  const selectors = normalizeSelector(current);

  const wantsFullStore = selector => selector(store) === store;

  return selectors.reduce((valid, sel) => valid && !wantsFullStore(sel), true);
}
/**
 * Convert input source to output value
 * Input source may be a factory OR the value itself.
 */


function valueFrom(source) {
  return typeof source === 'function' ? source() : source;
}

/**
 *  Utility `switchCase` to functionaly make case statements easy to process by
 *  using a case hashmap:
 *
 *  @Code
 *    (1) Used to perform quick lookups with fallbacks
 *
 *        const dayofWeek: SwitchCase<number, string> = switchCase({
 *          0: 'Sunday',
 *          1: 'Monday',
 *          2: 'Tuesday',
 *          3: 'Wednesday',
 *          4: 'Thursday',
 *          5: 'Friday',
 *          6: 'Saturday'
 *        },'Unknown'));
 *
 *        const currentDay = dayofWeek(new Date().getDay())
 *
 *
 *     (2)  Used to simply Redux state reducers:
 *
 *         export const counterReducer = <T extends ActionNames<typeof handleAction>>(
 *           state: number, action: { type: T }
 *         ) => {
 *           const handleAction = switchCase({
 *              'INCREMENT': () => state + 1,
 *              'DECREMENT': () => state - 1,
 *              'RESET': 0,
 *           }, state);
 *           return handleAction(action.type);
 *         };
 *
 *         console.log(counterReducer(0, { type: 'INCREMENT' }));      // perfect
 *         console.log(counterReducer("wrong", { type: 'FOO' }));      // intellisense shows errors
 *         console.log(counterReducer(0, { type: 'FOO' }));            // intellisense shows errors
 */
const findCaseValue = (cases, defaultCase) => {
  return key => cases[key] || defaultCase;
};

const switchCase = (cases, defaultCase) => {
  return key => {
    const f = findCaseValue(cases, defaultCase)(key);
    return f instanceof Function ? f() : f;
  };
};

export { CollectionEvent, DataPaginator, DependencyInjectionProvider, EventBus, InjectionToken, InjectorContext, ItemEvent, PAGE_SIZE, RxPaginator, Type, concatLatestFrom, createStore, destroyEventBus, isType, itemError, itemRemoved, itemUpdated, makeInjector, readAll, readFirst, rootInjector, switchCase, useDependencyInjector, useEventBus, useInjectorHook, useObservable, useStorePaginator };
